import { useEffect, useState } from "react";
import { getRaces } from "../../services/raceService";
import RaceForm from "./RaceForm";
import RaceTable from "./RaceTable";

function RacesPage() {
  const [races, setRaces] = useState([]);
  const [selectedRace, setSelectedRace] = useState(null);

  const fetchRaces = async () => {
    const data = await getRaces();
    setRaces(data);
  };

  useEffect(() => {
    fetchRaces();
  }, []);

  return (
    <div>
      <RaceForm
        selectedRace={selectedRace}
        refresh={fetchRaces}
        clearSelection={() => setSelectedRace(null)}
      />

      <RaceTable
        races={races}
        refresh={fetchRaces}
        setSelectedRace={setSelectedRace}
      />
    </div>
  );
}

export default RacesPage;